const getConstants = prop => Constants[prop]

export const versionText = {
	eaglePro: {
		title: getConstants('PRICING_NEW_COMMON_EAGLE_PRO'),
		originPrice: '¥ 559',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_PRO'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_360'),
	},
	eagleAdvance: {
		title: getConstants('PRICING_NEW_COMMON_EAGLE_ADVANCE'),
		originPrice: '¥ 919',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_ADVANCE'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_720'),
	},
}
